import Template from "../Template";
import "../../styles/employee/employee.css";
import { BsSearch } from "react-icons/bs";
import { useSelector } from "react-redux";
import EachCustOrEmploy from "./EachCustOrEmploy";
import EmployeeDetail from "./EmployeeDetail";
import AddEmployee from "./Addemployee";
import { useState, useEffect } from "react";
import { EmployeeManagement } from "./newInterface/EmployeeManagement";

const EmployeeScreen = () => {
  const [addEmployee, setAddEmployee] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [reload, setReload] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);

  useEffect(() => {
    setEmployees(user.employees);
    // console.log(employees);
  }, []);
  useEffect(() => {
    setEmployees(user.employees);
    console.log(employees);

    return () => {
      setReload(false);
      console.log("unmount");
    };
  }, [reload]);

  return (
    <Template>
      {/* <div className='EmployeWRapper'>
        <h3 className='sRTitle22'>Employee</h3>
        <div className='searchEmployeediv sRTitle22'>
          <input className='SearchTransact1 searchWarehouse ' placeholder='Search employee' />
          <span>
            <BsSearch />
          </span>
        </div>
        {employees.length > 0 ? (
          <div className='employeesDivcontainer'>
            <div>
              <div className='titleTap128'>
                <p>All</p>
                <div>
                  <span className='countEM4'>count:</span>
                  <span> {employees.length > 0 ? employees.length : 0} </span>
                </div>
              </div>

              <div className='EachCustEMploywrapper'>
                {" "}
                {employees
                  .slice()
                  .reverse()
                  .map((employee) => (
                    <EachCustOrEmploy
                      key={employee._id}
                      employee={employee}
                      updateSelectedEmployee={setSelectedEmployee}
                      selectedEmployee={selectedEmployee}
                      reload={setReload}
                    />
                  ))}
              </div>
            </div>
            <div>
              {selectedEmployee ? (
                <EmployeeDetail selectedEmployee={selectedEmployee} reload={setReload} />
              ) : (
                <div className='employeesDivcontainer'>
                  <div className='noEMployeeDiv'>
                    <p>Select an employee to view</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className='employeesDivcontainer'>
            <div className='noEMployeeDiv'>
              <h3>No employee added yet</h3>
              <p>
                Add new employees here and assign them <br /> to a store if you have created one{" "}
              </p>
            </div>
          </div>
        )}

        <div className='addEmployeediv22'>
          {user.store.length > 0 ? (
            <button onClick={() => setAddEmployee(true)}>Add employee</button>
          ) : (
            <button style={{ cursor: "not-allowed", opacity: "0.7" }}>Add employee</button>
          )}
        </div>
      </div>
      {addEmployee && <AddEmployee closeModal={setAddEmployee} reload={setReload} />} */}
      <EmployeeManagement />
    </Template>
  );
};

export default EmployeeScreen;
